import { DatePickerDate } from '../types';

export default function getSelectedDates({
  range,
  date,
  startDate,
  endDate,
}: {
  range?: boolean;
  date?: DatePickerDate | null;
  startDate?: DatePickerDate | null;
  endDate?: DatePickerDate | null;
}) {
  if (range) {
    return [startDate ?? null, endDate ?? null] as [
      DatePickerDate | null,
      DatePickerDate | null
    ];
  }

  return date ? [date] : null;
}
